import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'reactstrap';
import { LoadingComponent } from './LoadingComponent';

// #### name variabel recom
// dialogShow: false,
// dialogLoading: false,
// dialogTitle: '',
// dialogMessage: '',
// dialogActionConfirm : '',
// dialogData: null,
// dialogConfirm: null,

// <MaterialDialogConfirmation
// open={this.state.dialogShow}
// title={this.state.dialogTitle}
// confirmationMessage={this.state.dialogMessage}
// actionLoading={this.state.dialogLoading}
// actionCancel="Cancel"
// actionConfirm={this.state.dialogActionConfirm}
// onClickCancel={() => this.setState({dialogShow: false})}
// // onClickConfirm={this.confirmDialog}
// />

export function MaterialDialog({
  // dialog
  open,
  paperProps,
  transparent = false,
  scroll = 'paper', // paper || body
  fullWidth = true,
  maxWidth = 'sm',
  fullScreen,
  showClose = false,
  disableOnClose = false,
  disableOnClick = true,
  onClick,
  onClose,
  // content
  title,
  children
}) {
  let customStyle = {
    ...paperProps,
  }
  if (transparent) {
    customStyle = {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    }
  }
  if (!fullScreen && scroll === 'paper') {
    customStyle.margin = 12;
  }

  return (
    <Dialog
      className={fullScreen ? "" : "custom-dialog-paper"}
      PaperProps={{
        style: {
          ...customStyle,
        },
      }}
      open={open}
      scroll={scroll}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      fullScreen={fullScreen}
      onClose={disableOnClose ? null : onClose}
      onClick={disableOnClick ? null : onClick}
    >
      {(title || showClose) && (
        <DialogTitle >
          <div className="d-flex" style={{ justifyContent: 'space-between' }}>
            <div>{title}</div>
            {showClose && (<CloseIcon onClick={onClose ? onClose : null} className="cursor-pointer" title="Close dialog" />)}
          </div>
        </DialogTitle>
      )}
      <DialogContent>
        {children && React.cloneElement(children, { onClose: onClose })}
      </DialogContent>
    </Dialog>
  )
}

export function MaterialDialogConfirmation({
  // dialog
  open,
  fullWidth = true,
  maxWidth = 'xs',
  fullScreen,
  disableOnClose,
  onClose,
  showClose,
  transparent,
  paperProps,
  // content
  title,
  confirmationMessage,
  children,
  // action
  hideAction = false, // show hide action dialog
  actionLoading,
  actionCancel,
  actionConfirm,
  onClickCancel,
  onClickConfirm,
  disabledActionConfirm
}) {
  return (
    <MaterialDialog
      paperProps={paperProps}
      transparent={transparent}
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      fullScreen={fullScreen}
      title={title}
      onClose={onClose}
      showClose={showClose}
      disableOnClose={disableOnClose}
    >
      <div>
        {confirmationMessage && (
          <h5 className="mb-5">{confirmationMessage}</h5>
        )}
        {children}
        {!hideAction && (
          <MaterialDialogAction
            disabledActionConfirm={disabledActionConfirm}
            actionLoading={actionLoading}
            actionCancel={actionCancel}
            actionConfirm={actionConfirm}
            onClickCancel={onClickCancel}
            onClickConfirm={onClickConfirm}
          />
        )}
      </div>
    </MaterialDialog>
  )
}

export function MaterialDialogAction({
  disabledActionConfirm,
  actionLoading,
  actionCancel,
  actionConfirm,
  onClickCancel,
  onClickConfirm
}) {
  return (
    <LoadingComponent show={actionLoading} position="center">
      <div style={{ display: 'flex', justifyContent: 'center' }} className="mt-1">
        <Button
          className="btn-white mr-2 w-100"
          style={{ minWidth: 120, maxWidth: 'none', width: '100%' }}
          disabled={actionLoading}
          onClick={onClickCancel}>{actionCancel}</Button>
        <Button
          className="btn-green"
          disabled={actionLoading || disabledActionConfirm}
          style={{ minWidth: 120, maxWidth: 'none', width: '100%' }}
          onClick={onClickConfirm}>{actionConfirm}</Button>
      </div>
    </LoadingComponent>
  )
}